import { KeyDto, Key, fromDtoToKey, KeyRequest } from '@/core/chat/chat-keys/key';
import { Page } from '@/shared/pagination/export';
import axios from 'axios';

async function userKeys({
  page = 0,
  size = 10,
  filterOutStatus,
}: {
  page?: number;
  size?: number;
  filterOutStatus?: string;
}): Promise<Page<Key>> {
  const res: Page<KeyDto> = await axios
    .get(
      `/api/chat-service/keys?page=${page}&size=${size}${filterOutStatus ? `&status=${filterOutStatus}` : ''}`,
    )
    .then(value => value.data as any);
  return { ...res, content: res.content.map(fromDtoToKey) };
}

async function createKey(body: KeyRequest): Promise<Key> {
  const res = await axios
    .post<KeyDto>(`/api/chat-service/keys`, body)
    .then(value => value.data as any);
  return fromDtoToKey(res);
}

async function updateKey({ id, body }: { id: string; body: KeyRequest }): Promise<Key> {
  const res = await axios
    .put<KeyDto>(`/api/chat-service/keys/${id}`, body)
    .then(value => value.data as any);
  return fromDtoToKey(res);
}

async function revokeKey(id: string): Promise<Key> {
  const res = await axios
    .post<KeyDto>(`/api/chat-service/keys/${id}/revoke`)
    .then(value => value.data as any);
  return fromDtoToKey(res);
}

const chatServiceApi = {
  userKeys,
  createKey,
  updateKey,
  revokeKey,
};

export default chatServiceApi;
